// src/components/DocumentUploadPopup.js
import React, { useEffect, useState, useRef } from 'react';
import FileUpload from '../../../../Common/CommanFileUpload/fileUpload';
import { useDispatch } from 'react-redux';
import { getFileUploadReducer } from '../../../../../../redux/reducers/reducerSlices/FileuploadReducer';
import { useSelector } from 'react-redux';
import { showAlert, uuidv4 } from '../../../../../Assests/Utility';
import { toast } from 'react-toastify';
import { sagaActions } from '../../../../../../sagas/sagaActions';
import FilePreview from './FilePreview';
import CustomButtonSS from '../../../../Common/CustomButton/CustomButtonSS';
import { getEclipseOpsPaymentLoadselector } from '../../../../../../redux/reducers/reducerSlices/EclipseOpsPaymentLoadReducer';
import { ReactComponent as DownloadIconLight } from '../../../../../Assests/Svg/download-icon-light.svg';
import { ReactComponent as DownloadIconDark } from '../../../../../Assests/Svg/download-icon-dark.svg';
import { AppConstant } from '../../../../../Assests/AppConstant';
import Popup from '../../../../Common/Popup/Popup';
import _ from 'lodash-es'

/**
 * Reusable compoent to render upload document Popup with upload button and list pf uploaded documents
 * @param {*} props 
 * @returns 
 */

const EclipseOpsPaymentFileUpload = (props) => {
    const { onSubmit,exsistingFile,themeSelected,removeFile } = props
      const fileUploadData = useSelector(getFileUploadReducer);
          const eclipseOpsReducer = useSelector(getEclipseOpsPaymentLoadselector)
          const {fileUploadLoading,removeFileLoading } = eclipseOpsReducer;
    
      const dispatch = useDispatch();
    const [fileUrl,setFileUrl]=useState([])
    const [error,setError] = useState(null)
    const [loading,setLoading] = useState(false)
        const [showModal, setShowModal] = useState(false)
        const [selectedUrl,setSelectedUrl] = useState(null)
        const [selectedFileId,setSelectedFileId] = useState(null)
            const [currentIndex, SetCurrentIndex] = useState("NA")


                useEffect(()=>{
                    if (!removeFileLoading && currentIndex!=="NA") {
                        SetCurrentIndex("NA")
                        setFileUrl((prev)=>prev.filter((el)=>el.id !== selectedFileId))
                    }
                },[removeFileLoading])

    useEffect(()=>{
        if (exsistingFile) {
            const newFiles = [...exsistingFile,...fileUrl]
            const uniqueFiles = _.uniqBy(newFiles,"id")
            setFileUrl(uniqueFiles)
        }
    },[exsistingFile])

      useEffect(() => {
    if (fileUploadData?.data) {
      setLoading(false);
      if (fileUploadData.data.name) {
        setFileUrl((prev)=>[...prev,{id:uuidv4() ,fileUrl:fileUploadData?.data?.fileUrl,fileName:getDocName(fileUploadData?.data?.fileUrl)}]);
        dispatch({ type: sagaActions.RESET_FILE_UPLOAD });
      }
    } else {
      if (fileUploadData?.error) {
        setLoading(false);
        showAlert(toast.TYPE.ERROR, fileUploadData.error.message);
      }
    }

  }, [fileUploadData]);

      const onFileChange = async (fileData, name) => {
   
        if (!fileData) {
          return
        }
          const maxSizeInMB = 20;
          const fileSizeInMB = fileData.size / (1024 * 1024);

          if (fileSizeInMB > maxSizeInMB) {
            setError(`File size must not exceed ${maxSizeInMB} MB.`);
            return;
          }

        if (fileUrl && fileUrl.length >= 5 ) {
          setError("Maximum 5 files can be uploaded.")
          return
        }

         const timestamp = Date.now();
  const originalName = fileData.name;
  const extension = originalName.substring(originalName.lastIndexOf('.'));
  const baseName = originalName.substring(0, originalName.lastIndexOf('.'));
  const newFileName = `${baseName}-${timestamp}${extension}`;

  // Create a new File object with the updated name
  const renamedFile = new File([fileData], newFileName, { type: fileData.type });
        setLoading(true);
        setError(null)
        const fd = new FormData();
        fd.append("file", renamedFile);
        let fileUploadData = {
          name,
          fd
        }
        dispatch({ type: sagaActions.FILE_UPLOAD_BY_PRESIGNED_URL, payload: fileUploadData });
    
      };

      const handleSubmit=()=>{
        if (!fileUrl || fileUrl.length === 0) {
            setError("File is required!")
            return
        }
        onSubmit(fileUrl)
      }

      const handleFileRemove=(url,id)=>{
        if (!url) {
          setError("File is required!")
          return
        }
        setSelectedUrl(url)
        setSelectedFileId(id)
        setShowModal(true)
      }


          const fileRemovePopup = () => {
        const popupObj = {
            id: 'fileRemovePopup',
            modalLabel: 'fileRemovePopup',
            showClose: true,
            showfooter: true,
            showHeader: true,
            sendDriverNotification: false,
            modalSize: 'md',
            title: "Remove File",
            bodyText: AppConstant.commonStrings.areYouSure + ' remove this file ?',
            subText: "",
            keyboard: false,
            backdrop: "static",
            footerBtn: {
                btn1: {
                    show: true,
                    text: AppConstant.commonStrings.no
                },
                btn2: {
                    show: true,
                    text: AppConstant.commonStrings.yes
                }
            },
        }

        return <Popup {...popupObj} popupBtnHandler={(text) => deleteFileHandler(text)} closepopup={() => { closeModal() }} themeSelected={themeSelected} showModal={showModal} />
    }

        const closeModal = () => {
        setShowModal(false);
    }

            const deleteFileHandler = (text) =>{
                if (text=== AppConstant.commonStrings.yes) {
                  SetCurrentIndex(selectedFileId)
                    removeFile(selectedUrl)
                    setShowModal(false)
                }else{
                    closeModal()
                }
            }
    
       const getDocName = (doc) => {
  if (!doc) return "-";

  try {
    const url = new URL(doc);
    const pathname = url.pathname; // e.g. "/uploads/my%20file.pdf"
    const fileName = decodeURIComponent(pathname.substring(pathname.lastIndexOf('/') + 1));
    return fileName || null;
  } catch (err) {
    // fallback in case it's not a valid URL
    const parts = doc.split('/');
    return decodeURIComponent(parts[parts.length - 1]) || "-";
  }
};
          

    return (
        <>
        <div className='d-flex align-items-center justify-content-center border rounded p-3 bg-light text-success'>
         <FileUpload
            showError={""}
            accept={"*"}
            title={"Upload File"}
            name={"fileUrl"}
            sizeConfig={<span>Note: Maximum file size allowed is 20 MB.<br/>Maximum 5 file can upload.</span>}
            onFileChange={onFileChange}
            isLoading={{loading:loading}}
            showImageLogo={false}
            imageSrc={""}
          />
         
          </div>
           {error && (
        <span className="errorMessage">
          {error ? error : error}
        </span>
      )}
        <div className='d-flex justify-content-end mt-4 gap-4'>
          {/* {fileUrl && <a
                  href={fileUrl}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-reschedule "
                  style={{border:"1px solid black"}}
                >
                 {themeSelected === 'light-mode' ? <DownloadIconLight className='me-2' /> : <DownloadIconDark className='me-2' />}Download</a>}
                {fileUrl && <CustomButtonSS
                isLoading={removeFileLoading}
                title={"Remove File"}
                className={"btn btn-approve "}
                onClick={handleFileRemove}
              />}   */}
          <CustomButtonSS
                isLoading={fileUploadLoading}
                disabled={_.isEqual(exsistingFile,fileUrl)}
                title={"Submit"}
                className={"btn btn-approve "}
                onClick={handleSubmit}
              />
              </div>
           {/* <FilePreview fileUrl={fileUrl} themeSelected={themeSelected}/> */}
          <ul className="list-group mt-3">
                            {fileUrl && fileUrl.length>0 && fileUrl?.map((doc, index) => (
                                <li key={Math.random()} className="list-group-item d-flex justify-content-between align-items-center">
                                    <span className='text-truncate w-50'>{getDocName(doc.fileUrl)}</span>
                                    <div className='w-50 d-flex justify-content-end'>
                                        <CustomButtonSS
                                            disabled={false}
                                            isLoading={false}
                                            className={`carrier-po-btn-small`}
                                            onClick={() => { 
                                                window.open(doc.fileUrl, '_blank');
                                            }}
                                            isIcon={true}
                                            iconClass={"fa-regular fa-eye"}
                                        />
                                     
                                             <CustomButtonSS
                                             disabled={false}
                                             isLoading={currentIndex === doc.id ? true : false}
                                             className={`carrier-po-btn-small`}
                                             onClick={() => { handleFileRemove(doc.fileUrl,doc.id)}}
                                             isIcon={true}
                                             iconClass={"fa-regular fa-trash"}
                                             loadingTitle=""
                                         /> 
                                    </div>
                                </li>
                            ))}
                                </ul>
         {fileRemovePopup()}
        </>
    );
};

export default EclipseOpsPaymentFileUpload;
